import { makeNarrativeLabel } from "./defaultFictionNarrativeLabels";

export const DefaultLegalNarrativeLabelIds = {
  Part: "narrativeLabelPart",
  Section: "narrativeLabelSection",
  Argument: "narrativeLabelArgument",
  CounterArgument: "narrativeLabelCounterArgument",
  Closing: "narrativeLabelClosing"
};

export default [
  makeNarrativeLabel(DefaultLegalNarrativeLabelIds.Part, "Part", true, false),
  makeNarrativeLabel(DefaultLegalNarrativeLabelIds.Section, "Section", true, false),
  makeNarrativeLabel(DefaultLegalNarrativeLabelIds.Argument, "Argument", false, true),
  makeNarrativeLabel(DefaultLegalNarrativeLabelIds.CounterArgument, "Counterargument", false, false),
  makeNarrativeLabel(DefaultLegalNarrativeLabelIds.Closing, "Closing", false, false)
];
